module.exports = __webpack_public_path__ + "static/img/office (14).ba4e6a47.jpg";